<template>
  <div class="container">
    <el-form size="mini" :model="searchInfo" inline class="status-form">
      <el-row>
        <el-col :span="8">
          <el-form-item label="类型:" prop="log_type">
            <el-radio-group
              v-model="searchInfo.log_type"
              @change="handleSearch('log_type')"
            >
              <el-radio-button :label="-1">全部</el-radio-button>
              <el-radio-button label="follow_log">跟进记录</el-radio-button>
              <el-radio-button label="follow_staff_log">
                跟进人变动
              </el-radio-button>
              <el-radio-button label="experience">体验记录</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="动态时间:" prop="time">
            <el-date-picker
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              v-model="searchInfo.time"
              @change="handleSearch"
              class="date-picker"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="content-wrap">
      <div v-for="(item, index) in tableData" :key="index" class="content-item">
        <div class="title flex">
          <div class="btn font-size-14" v-if="item.log_type === 1">
            跟进记录
          </div>
          <div class="btn font-size-14" v-if="item.log_type === 2">
            跟进人变动
          </div>
          <div class="btn font-size-14" v-if="item.log_type === 3">
            预约体验
          </div>
          <div class="btn font-size-14" v-if="item.log_type === 4">
            完成体验
          </div>
          <div class="btn font-size-14" v-if="item.log_type === 5">
            取消体验
          </div>
          <div class="border"></div>
          <div class="font-size-14 time-color">
            {{ handleCreateTime(item) }}
          </div>
        </div>
        <!-- 跟进记录 -->
        <div class="main" v-if="item.log_type === 1">
          <div class="user-info flex">
            <div class="user-info-item flex font-size-14 content-color">
              <span>跟进人：</span>
              <span>{{
                item.follow_log.staff ? item.follow_log.staff.name : "-"
              }}</span>
            </div>
            <div class="border"></div>
            <div class="user-info-item flex font-size-14 content-color">
              <span>沟通方式：</span>
              <span v-if="item.follow_log.mode == 1">电话</span>
              <span v-else-if="item.follow_log.mode == 2">微信</span>
              <span v-else-if="item.follow_log.mode == 3">到访</span>
              <span v-else-if="item.follow_log.mode == 4">介绍</span>
              <span v-else-if="item.follow_log.mode == 5">其他</span>
              <span v-else>-</span>
            </div>
            <div class="border"></div>
            <div class="user-info-item flex font-size-14 content-color">
              <span>用户意向：</span>
              <span class="user-intent">{{
                followLatentObj[item.follow_log.intent] || "-"
              }}</span>
            </div>
          </div>
          <div class="follow-content flex font-size-14 content-color">
            <span>跟进内容：</span>
            <span class="flex" style="align-items: center">
              <span
                :class="{ 'margin-right-20': item.follow_log.content }"
                v-if="
                  item.follow_log.content ||
                  item.follow_log.images_url.length > 0
                "
                >{{ item.follow_log.content }}</span
              >
              <span class="margin-right-20" v-else>-</span>
              <el-popover
                placement="right"
                trigger="hover"
                v-for="img in item.follow_log.images_url"
                :key="img"
              >
                <img height="240" :src="img" />
                <a
                  :href="img"
                  slot="reference"
                  target="_blank"
                  class="follow-a"
                >
                  <el-image
                    style="width: 50px; height: 50px"
                    fit="cover"
                    :src="img"
                  />
                </a>
              </el-popover>
            </span>
          </div>
        </div>
        <!-- 跟进人变动 -->
        <div class="main" v-if="item.log_type === 2">
          <div class="user-info flex">
            <div class="user-info-item flex font-size-14 content-color">
              <span>变动后跟进人：</span>
              <span>{{
                item.follow_staff_log.staff_after
                  ? item.follow_staff_log.staff_after.name
                  : "-"
              }}</span>
            </div>
            <div class="border"></div>
            <div class="user-info-item flex font-size-14 content-color">
              <span>变动前跟进人：</span>
              <span>{{
                item.follow_staff_log.staff_before
                  ? item.follow_staff_log.staff_before.name
                  : "-"
              }}</span>
            </div>
          </div>
          <div class="follow-content flex font-size-14 content-color">
            <span>变动内容：</span>
            <span>{{
              item.follow_staff_log.content
                ? item.follow_staff_log.content
                : "-"
            }}</span>
          </div>
        </div>
        <!-- 预约体验 -->
        <div class="main" v-if="item.log_type === 3">
          <div class="follow-content flex">
            <div class="follow-content-item flex font-size-14 content-color">
              <span>授课教师：</span>
              <span v-if="item.experience.teacher_list.length > 0">{{
                item.experience.teacher_list.map((item) => item.name).join("、")
              }}</span>
              <span v-else>-</span>
            </div>
            <div class="border"></div>
            <div class="follow-content-item flex font-size-14 content-color">
              <span>上课课程：</span>
              <span>{{
                item.experience.course ? item.experience.course.title : "-"
              }}</span>
            </div>
          </div>
          <div class="user-info flex">
            <div class="user-info-item flex font-size-14 content-color">
              <span>班级：</span>
              <span>{{
                item.experience.class ? item.experience.class.name : "-"
              }}</span>
            </div>
            <div class="border"></div>
            <div class="user-info-item flex font-size-14 content-color">
              <span>上课教室：</span>
              <span>{{
                item.experience.class_room.name
                  ? item.experience.class_room.name
                  : "-"
              }}</span>
            </div>
            <div class="border"></div>
            <div class="user-info-item flex font-size-14 content-color">
              <span>授课模式：</span>
              <span>{{
                item.experience.lesson_type === 1 ? "线下" : "线上"
              }}</span>
            </div>
            <div class="border"></div>
            <div class="user-info-item flex font-size-14 content-color">
              <span>预约体验时间：</span>
              <span>{{ item.experience.lesson_date.slice(0, -3) }}</span>
            </div>
            <div class="border"></div>
            <div class="user-info-item flex font-size-14 content-color">
              <span>预约操作人：</span>
              <span>{{
                item.experience.staff ? item.experience.staff.name : "-"
              }}</span>
            </div>
          </div>
        </div>
        <!-- 完成体验 -->
        <div class="main" v-if="item.log_type === 4">
          <div class="follow-content flex">
            <div class="follow-content-item flex font-size-14 content-color">
              <span>预约操作人：</span>
              <span>{{
                item.experience.staff ? item.experience.staff.name : "-"
              }}</span>
            </div>
            <div class="border"></div>
            <div class="follow-content-item flex font-size-14 content-color">
              <span>上课课程：</span>
              <span>{{
                item.experience.course ? item.experience.course.title : "-"
              }}</span>
            </div>
          </div>
          <div class="user-info flex">
            <div class="user-info-item flex font-size-14 content-color">
              <span>班级：</span>
              <span>{{
                item.experience.class ? item.experience.class.name : "-"
              }}</span>
            </div>
            <div class="border"></div>
            <div class="user-info-item flex font-size-14 content-color">
              <span>授课教师：</span>
              <span v-if="item.experience.teacher_list.length > 0">{{
                item.experience.teacher_list.map((item) => item.name).join("、")
              }}</span>
              <span v-else>-</span>
            </div>
            <div class="border"></div>
            <div class="user-info-item flex font-size-14 content-color">
              <span>预约体验时间：</span>
              <span>{{ item.experience.lesson_date.slice(0, -3) }}</span>
            </div>
            <div class="border"></div>
            <div class="user-info-item flex font-size-14 content-color">
              <span>上课教室：</span>
              <span>{{
                item.experience.class_room.name
                  ? item.experience.class_room.name
                  : "-"
              }}</span>
            </div>
            <div class="border"></div>
            <div class="user-info-item flex font-size-14 content-color">
              <span>授课模式：</span>
              <span>{{
                item.experience.lesson_type === 1 ? "线下" : "线上"
              }}</span>
            </div>
          </div>
        </div>
        <!-- 取消体验 -->
        <div class="main" v-if="item.log_type === 5">
          <div class="follow-content flex">
            <div class="follow-content-item flex font-size-14 content-color">
              <span>取消操作人：</span>
              <span>{{
                item.experience.staff ? item.experience.staff.name : "-"
              }}</span>
            </div>
            <div class="border"></div>
            <div class="user-info-item flex font-size-14 content-color">
              <span>上课课程：</span>
              <span>{{
                item.experience.course ? item.experience.course.title : "-"
              }}</span>
            </div>
          </div>
          <div class="user-info flex">
            <div class="user-info-item flex font-size-14 content-color">
              <span>班级：</span>
              <span>{{
                item.experience.class ? item.experience.class.name : "-"
              }}</span>
            </div>
            <div class="border"></div>
            <div class="user-info-item flex font-size-14 content-color">
              <span>授课教师：</span>
              <span v-if="item.experience.teacher_list.length > 0">{{
                item.experience.teacher_list.map((item) => item.name).join("、")
              }}</span>
              <span v-else>-</span>
            </div>
            <div class="border"></div>
            <div class="user-info-item flex font-size-14 content-color">
              <span>预约体验时间：</span>
              <span>{{ item.experience.lesson_date.slice(0, -3) }}</span>
            </div>
            <div class="border"></div>
            <div class="user-info-item flex font-size-14 content-color">
              <span>上课教室：</span>
              <span>{{
                item.experience.class_room.name
                  ? item.experience.class_room.name
                  : "-"
              }}</span>
            </div>
            <div class="border"></div>
            <div class="user-info-item flex font-size-14 content-color">
              <span>授课模式：</span>
              <span>{{
                item.experience.lesson_type === 1 ? "线下" : "线上"
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-empty
      :image-size="32"
      v-if="tableData.length == 0"
      description="暂未有学员动态记录"
      image="https://wowsite.musicwow.com/teaching_system_frontend/images/studying/nodata.png"
    ></el-empty>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
  </div>
</template>
<script>
import { getDynamicListApi } from "@/api/studyDetails";
import { dateFormat } from "@/utils/timeFormat";
import { getFollowLatentApi } from "@/api/studentFollow";

export default {
  name: "",
  props: {
    update: {
      type: Boolean,
    },
  },
  data() {
    return {
      searchInfo: {
        time: "",
        log_type: -1,
      },
      tableData: [],
      followLatentObj: {},
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
    };
  },
  watch: {
    update: {
      handler() {
        this.getList({
          page: 1,
          page_size: this.pageSize,
        });
      },
    },
  },
  created() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
    getFollowLatentApi().then((res) => {
      this.followLatent = res.data.list;
      const obj = {};
      res.data.list.map((item) => {
        obj[item.key] = item.value;
      });
      this.followLatentObj = obj;
    });
  },
  methods: {
    solveSearchInfo(options) {
      let params = { ...options };
      if (this.searchInfo.time && this.searchInfo.time.length > 0) {
        params.start_time = this.searchInfo.time[0];
        params.end_time = this.searchInfo.time[1];
      }
      if (this.searchInfo.log_type && this.searchInfo.log_type !== -1) {
        params.log_type = this.searchInfo.log_type;
      }
      params.student_id = this.$route.query.id;
      return params;
    },
    getList(options) {
      let params = this.solveSearchInfo(options);
      getDynamicListApi(params).then((res) => {
        if (res.error_code === 0) {
          this.tableData = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    handleCreateTime(item) {
      let createTime = "";
      if (item.log_type === 1 && item.follow_log) {
        createTime = dateFormat(
          "YYYY-mm-dd HH:MM",
          item.follow_log.create_time * 1000
        );
      } else if (item.log_type === 2 && item.follow_staff_log) {
        createTime = dateFormat(
          "YYYY-mm-dd HH:MM",
          item.follow_staff_log.create_time * 1000
        );
      } else if (
        (item.log_type === 3 || item.log_type === 4 || item.log_type === 5) &&
        item.experience
      ) {
        createTime = dateFormat(
          "YYYY-mm-dd HH:MM",
          item.experience.create_time * 1000
        );
      }
      return createTime;
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 0 15px;
  /deep/.status-form {
    margin-bottom: 8px;
    .el-form-item {
      display: flex;
      .el-form-item__label {
        min-width: 70px;
      }
      .el-form-item__content {
        width: 100%;
      }
    }
  }
  .content-wrap {
    .content-item {
      border: 1px solid rgba(231, 232, 234, 1);
      border-radius: 10px;
      margin-bottom: 12px;
      padding: 15px 15px 0 15px;
      &:last-child {
        margin-bottom: 0px;
      }
      .title {
        .btn {
          padding: 6px 15px;
          background: rgba(230, 250, 246, 1);
          color: rgba(5, 209, 170, 1);
          border-radius: 4px;
          margin-right: 20px;
          cursor: default;
        }
        margin-bottom: 15px;
      }
      .main {
        .user-info {
          margin-bottom: 20px;
          .user-info-item {
            margin-right: 20px;
            .user-intent {
              padding: 3px 5px;
              background: rgba(230, 250, 246, 1);
              color: rgba(5, 209, 170, 1);
              border-radius: 4px;
            }
          }
        }
        .follow-content {
          margin-bottom: 20px;
          .follow-content-item {
            margin-right: 20px;
          }
          .follow-a {
            display: inline-block;
            width: 50px;
            height: 50px;
            border-radius: 4px;
            overflow: hidden;
            margin-right: 20px;
            vertical-align: top;
          }
          .margin-right-20 {
            margin-right: 20px;
          }
        }
      }
    }

    .border {
      border-right: 2px solid rgba(231, 232, 234, 1) !important;
      margin-right: 20px;
      height: 16px;
    }
  }
}
.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.font-size-14 {
  font-size: 14px;
}
.time-color {
  color: rgba(162, 165, 168, 1);
}
.content-color {
  color: rgba(92, 93, 94, 1);
}
</style>
